export enum SearchDataDefaultType {
  COUNTRY = 'COUNTRY',
  CITY = 'CITY',
  AIRPORT = 'AIRPORT',
  BUS = 'BUS'
}

export type SearchDataDefault = Readonly<{
  Marks: SearchDataDefaultUbication[]
}>;

export type SearchDataDefaultUbication = Readonly<{
  Code: string,
  Name: string,
  CountryCode: string,
  CountryName: string,
  Type: string,
  Nears: SearchDataDefaultUbication[]
}>;
